// Country + Malaysian state / region reference data used by the
// Edit Profile screen. Kept small and dependency-free — if we ever need
// full ISO-3166 coverage we can swap this for `world-countries`.

export const COUNTRIES = [
  "Malaysia",
  "Singapore",
  "Indonesia",
  "Thailand",
  "Philippines",
  "Vietnam",
  "Brunei",
  "Cambodia",
  "Laos",
  "Myanmar",
  "Australia",
  "New Zealand",
  "Japan",
  "South Korea",
  "China",
  "Taiwan",
  "Hong Kong",
  "India",
  "United States",
  "Canada",
  "United Kingdom",
  "Germany",
  "France",
  "Netherlands",
  "Italy",
  "Spain",
  "Sweden",
  "Norway",
  "Finland",
  "Denmark",
  "Switzerland",
  "Austria",
  "Belgium",
  "Ireland",
  "Portugal",
  "United Arab Emirates",
  "Saudi Arabia",
  "Qatar",
  "Kuwait",
  "Turkey",
  "South Africa",
  "Brazil",
  "Mexico",
  "Argentina",
  "Chile",
  "Other",
];

// 13 states + 3 federal territories (Wilayah Persekutuan).
export const MY_STATES = [
  "Johor",
  "Kedah",
  "Kelantan",
  "Melaka",
  "Negeri Sembilan",
  "Pahang",
  "Perak",
  "Perlis",
  "Pulau Pinang",
  "Sabah",
  "Sarawak",
  "Selangor",
  "Terengganu",
  "W.P. Kuala Lumpur",
  "W.P. Labuan",
  "W.P. Putrajaya",
];
